import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';
import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { Provider } from './provider';

@inheritSerialization(AbstractModel)
export class TransitProgramProvider extends AbstractModel {
  @autoserialize
  transitProgramId: number;

  @autoserializeAs(Provider)
  provider: Provider;

  @autoserialize
  active: boolean;

  @autoserializeAs(Date)
  effectiveDate: Date;

  constructor() {
    super();
    this.active = true;
  }

  /**** Serialization ****/

  static OnSerialized(instance: TransitProgramProvider, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.effectiveDate)) {
      json.effectiveDate = DateUtil.serializeDate(instance.effectiveDate);
    }
  }

  static OnDeserialized(instance: TransitProgramProvider, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['effectiveDate'])) {
      instance.effectiveDate = DateUtil.deserializeDate(json['effectiveDate']);
    }
  }
}
